export default [
  {
    name: 'ВКонтакте',
    mod: 'vk',
    link: 'https://vk.com/banketniy_stul'
  },
  {
    name: 'Telegram',
    mod: 'tg',
    link: 'https://t.me/Chiedocover_tgbot'
  }
]
